const updates = [
  { time: '2026.07.18 14:32', title: '某知名带货主播税务问题被税务部门约谈', summary: '据知情人士透露，约谈涉及近三年直播收入申报细节，可能面临巨额补缴与罚款' },
  { time: '2026.07.18 11:15', title: '网红餐饮连锁品牌多地门店突遭检查', summary: '消费者举报食材过期问题持续发酵，已有三家门店被责令停业整顿' },
  { time: '2026.07.18 09:48', title: '顶流综艺节目录制现场爆发冲突', summary: '两位常驻嘉宾因节目效果分歧当场翻脸，节目组紧急协调中，后续录制暂缓' },
  { time: '2026.07.18 07:20', title: '知名艺人工作室凌晨发布律师函', summary: '针对近期网络传播的多条不实信息，工作室表示已取证并将追究法律责任' },
  { time: '2026.07.17 22:05', title: '圈内人士匿名爆料某平台内容审核黑幕', summary: '爆料称平台存在选择性审核，对特定艺人负面内容刻意限流甚至删除' },
  { time: '2026.07.17 18:40', title: '短视频平台头部创作者的MCN机构陷合同纠纷', summary: '多名签约达人集体维权，指控机构抽成比例过高且存在霸王条款，律师已介入' },
  { time: '2026.07.17 15:22', title: '知名品牌代言人连夜解约，品牌方紧急更换广告', summary: '受近期负面事件影响，多个品牌已终止合作，艺人商业价值面临重估' },
  { time: '2026.07.17 12:08', title: '娱乐圈某经纪公司被曝阴阳合同', summary: '匿名人士提供多份合同复印件显示，公司与艺人之间存在双面签约行为' },
  { time: '2026.07.17 08:55', title: '吃瓜群众注意：今日多平台同步大瓜预警', summary: '据多渠道汇总，今天将有多起重磅爆料陆续公开，编辑团队已全员待命追踪' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-8 md:mb-10">
          实时快讯
        </h2>

        <div className="relative pl-6 md:pl-8">
          <div className="absolute left-0 top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-6 md:space-y-8">
            {updates.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[27px] md:-left-[35px] top-1.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 md:border-[3px] border-background-50 bg-accent-500"></div>

                <span className="inline-block px-2 py-0.5 bg-foreground-100 text-foreground-600 text-xs rounded-md font-medium mb-1.5">
                  {item.time}
                </span>
                <h3 className="text-foreground-900 font-bold text-sm md:text-base leading-snug mb-1">{item.title}</h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">{item.summary}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}